export const sanitizeRegex = (regex: string): RegExp | null => {
    return tryParseRegex(regex);
};

export const isMatchWithRegex = (regex: string, value: any): boolean => {
    const pattern = sanitizeRegex(regex);
    return pattern ? pattern.test(value) : false;
};

export const tryParseRegex = (regex: string): RegExp | null => {
    try {
        if (regex.startsWith('/') && regex.lastIndexOf('/') > 0) {
            const lastSlashIndex = regex.lastIndexOf('/');
            const body = regex.slice(1, lastSlashIndex);
            const flags = regex.slice(lastSlashIndex + 1);
            return new RegExp(body, flags);
        } else {
            return new RegExp(regex);
        }
    } catch {
        return null;
    }
};
